import React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { tour24Faqs } from '../../../../data/information';
import { browserHistory } from '../../../../utilities/history';
import FaqExpandable from '../../../common/FaqExpandable';

const sideImage = require('../../../../images/faq-hero-image.png');

interface Props {
    simple: boolean;
    webTour: boolean;
}

const FaqsLayout = (props: Props) => {
    const backArrow = require('../../../../images/white-left-carot-large.png');
    return (
        <Row className="tour24-faq-page">
            <Col lg={6} className="d-none d-lg-flex hero-image-column">
                <img src={sideImage} />
            </Col>
            <Col xs={12} lg={6} className="faqs-column">
                <section className="title-bar">
                    <Row>
                        <Col xs={2}>
                            <div className="back-button" onClick={browserHistory.goBack}>
                                <img src={backArrow} />
                            </div>
                        </Col>
                        <Col className="text-center large-text" xs={8}>
                            <label className="large-text">FAQ</label>
                        </Col>
                        <Col xs={2} />
                    </Row>

                    <label>FREQUENTLY ASKED QUESTIONS</label>
                </section>
                <section>
                    {tour24Faqs
                        .filter(f => (props.simple ? !f.fullFaqsOnly : true))
                        .filter(f => (props.webTour ? f.webTourFaq : !f.webTourFaq))
                        .map((f, index) => (
                            <FaqExpandable
                                questionText={f.question}
                                answerText={f.answer}
                                key={index}
                            />
                        ))}
                </section>
            </Col>
        </Row>
    );
};

export default FaqsLayout;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/FaqsLayout.tsx